// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"688":"3f30ccb1","716":"73da10d7"}[chunkId] + ".chunk.css");